import React from 'react';
import styled from '@benzinga/themetron';

interface CustomTooltip {
  active?: boolean;
  label?: string;
  payload?: Payload[];
}

interface Payload {
  stroke: string;
  strokeWidth: number;
  fill: string;
  points: any[];
  dataKey: string;
  name: string;
  color: string;
  value: number;
  payload: {
    name: boolean;
  };
}

export const CustomTooltip: React.FC<CustomTooltip> = ({ active, label, payload }) => {
  if (active && payload && payload.length) {
    return (
      <Container className="covey-analyst-chart-tooltip">
        <span className="label">{label}</span>
        {payload.map(item => (
          <PointInfo key={item.name} {...item} />
        ))}
      </Container>
    );
  }

  return null;
};

const PointInfo = (data: Payload) => {
  const valueFormatter = (value: number) => {
    if (isNaN(value)) return null;
    return value.toFixed(2);
  };

  return (
    <div className="point-info">
      <span className="point-circle" style={{ backgroundColor: data.color }} />
      <span className="point-label">{data.name}: </span>
      <span className="point-value">{valueFormatter(data.value)}</span>
    </div>
  );
};

export default CustomTooltip;

const Container = styled.div`
  &.covey-analyst-chart-tooltip {
    display: flex;
    flex-direction: column;
    background-color: white;
    border-radius: ${({ theme }) => theme.borderRadius.sm};
    border: 1px solid ${({ theme }) => theme.colorPalette.gray400};
    padding: 0.75rem;
    .label {
      font-size: ${({ theme }) => theme.fontSize.sm};
      font-weight: ${({ theme }) => theme.fontWeight.semibold};
    }

    .point-info {
      .point-circle {
        width: 8px;
        height: 8px;
        display: inline-block;
        margin-right: 5px;
      }
      .point-label {
        color: ${({ theme }) => theme.colorPalette.gray600};
        font-size: ${({ theme }) => theme.fontSize.sm};
      }
      .point-value {
        color: ${({ theme }) => theme.colorPalette.gray800};
        font-size: ${({ theme }) => theme.fontSize.sm};
        font-weight: ${({ theme }) => theme.fontWeight.semibold};
      }
    }
  }
`;
